import React from 'react';
import {media, tokens, view} from '@sail/ui';

import {Header} from 'src/return/Header';
import {Footer} from 'src/v2/components/screen/Footer';
import {MEDIA_QUERIES} from 'src/v2/util/mediaQueries';

type LayoutProps = {
  children: React.ReactNode;
};

export const Layout = ({children}: LayoutProps): React.ReactElement => {
  return (
    <view.div
      css={{
        width: 'fill',
        height: '100dvh',
        stack: 'y',
        gapY: 'space.0',
        backgroundColor: 'surface',
        // Display scroll bars only if the content is overflowing
        overflow: 'auto',
        paddingBottom: 'space.500',
        [media.down(tokens.viewport.medium)]: {
          paddingBottom: 'large',
        },
      }}
    >
      <Header />
      {children}
      <view.div
        css={{
          paddingTop: 'space.500',
          [MEDIA_QUERIES.mediumWidth]: {
            paddingTop: 'space.0',
          },
          height: 'fit',
        }}
      >
        <Footer />
      </view.div>
    </view.div>
  );
};
